import * as React from 'react';

import { StripeProvider, Elements } from 'react-stripe-elements';
import StripeAPI from 'lib/StripeAPI';
import ToastActions from 'actions/ToastActions';
import LinkConstants from 'constants/LinkConstants';
import LoadingIndicator from 'components/LoadingIndicator';
import CreditCardInputField from './CreditCardInputField';

type State = {
  loadingStripeScript: boolean;
};

type Props = {
  apiKey: string;
};

class CreditCardInput extends React.Component<Props, State> {
  state: State = {
    loadingStripeScript: true,
  };

  componentDidMount() {
    StripeAPI.load().then(this.handleStripeScriptLoaded, this.handleStripeScriptError);
  }

  handleStripeScriptError = () => {
    ToastActions.showErrorToast(
      `
      There was an error. Please try again, or email
      ${LinkConstants.SUPPORT_EMAIL}
      for help.
    `
    );
  };

  handleStripeScriptLoaded = () => {
    this.setState({ loadingStripeScript: false });
  };
  render() {
    const { loadingStripeScript } = this.state;

    return (
      <div>
        {loadingStripeScript ? (
          <LoadingIndicator />
        ) : (
          <StripeProvider apiKey={this.props.apiKey}>
            <Elements>
              <CreditCardInputField />
            </Elements>
          </StripeProvider>
        )}
      </div>
    );
  }
}

export default CreditCardInput;
